import { use_slice_generation } from '@/hooks/store/use_slices';
import { UTILS__ml_asset } from '@/utils/UTILS__ml_asset';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { DTO__generation_tool_grid2d_view } from '@shared/dto/generation/DTO__generation_tool_grid2d_view';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD__list_base_generic } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_base_generic';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { useMemo } from 'react';

interface PROPS {
  view: DTO__generation_tool_grid2d_view;
}

export function G_LIST_ITEM__generation_tools_view_info({ view }: PROPS) {
  const { generation_current } = use_slice_generation(['generation_current']);

  const fields_map = useMemo(() => get_fields_map(), [generation_current]);

  /*
   *
   */
  function get_fields_map() {
    if (generation_current.is_stub()) return new MAP__serializable<string, FIELD__base>();

    return generation_current.tool.graph.fields__get_map();
  }

  /*
   *
   */

  function render_info__has_affect_on_generation() {
    if (view.field_id_info__has_affect_on_generation.is_empty_uuid()) return null;
    if (!fields_map.has(view.field_id_info__has_affect_on_generation)) return render_line_not_found();

    let field = fields_map.get_or_assert(view.field_id_info__has_affect_on_generation);
    field = field.find_source(generation_current.tool.graph);

    let has_effect = generation_current.tool.graph.node_and_field__has_effect_on_generation_runtime(field);

    return render_line(`${has_effect ? 'Has' : 'No'} effect`, has_effect);
  }

  function render_info__items_amount() {
    if (view.field_ids_info__items_amount.is_empty()) return null;

    let total_amount = 0;

    for (let field_id of view.field_ids_info__items_amount) {
      if (!fields_map.has(field_id)) return render_line_not_found();

      let field = fields_map.get_or_assert(field_id);
      field = field.find_source(generation_current.tool.graph);

      if (!(field instanceof FIELD__list_base_generic)) return render_line_wrong_type();

      let items = [...field.items];

      items = items.filter(item => generation_current.tool.graph.node_and_field__has_effect_on_generation_runtime(item));

      total_amount += items.length;
    }

    return render_line(`Used: ${total_amount}`, total_amount > 0);
  }

  function render_info__ml_asset() {
    if (view.field_id_info__ml_asset.is_empty_uuid()) return null;
    if (!fields_map.has(view.field_id_info__ml_asset)) return render_line_not_found();

    let field = fields_map.get_or_assert(view.field_id_info__ml_asset);
    field = field.find_source(generation_current.tool.graph);

    if (!(field instanceof FIELD_PRIMITIVE__string_hash_ml_asset)) return render_line_wrong_type();

    assert_instanceof(field, FIELD_PRIMITIVE__string_hash_ml_asset);

    let [name, version] = UTILS__ml_asset.get_name_and_version(field.get_value());

    return render_line(`${name} ${version}`);
  }

  function render_line_not_found() {
    return render_line('Info field not found', false);
  }

  function render_line_wrong_type() {
    return render_line('Info field wrong type', false);
  }

  function render_line(text: string, is_active: boolean = true) {
    return (
      <div
        className={`pl-2.5 w-full text-xs text-bar-foreground truncate
      ${is_active ? 'opacity-50' : 'opacity-25'}
      `}
      >
        {text}
      </div>
    );
  }

  /*
   *
   */

  if (generation_current.is_stub()) return null;
  if (view.get_info_all_are_empty()) return null;

  return (
    <>
      <div className="flex flex-col gap-0.5">
        {render_info__has_affect_on_generation()}
        {render_info__items_amount()}
        {render_info__ml_asset()}
      </div>
    </>
  );
}
